module.exports = __webpack_public_path__ + "static/media/share-availability.bb107e64.svg";